import React from 'react'
import HelpPopup from '../../helpPopup/HelpPopup'
import AloCheckbox from '../../aloCheckbox/AloCheckbox'

import IntroductoryIcon from '../../../../assets/codicons/introductory.svg'
import BeginnerIcon from '../../../../assets/codicons/beginner.svg'
import ModerateIcon from '../../../../assets/codicons/moderate.svg'
import IntermediateIcon from '../../../../assets/codicons/intermediate.svg'
import AdvancedIcon from '../../../../assets/codicons/advanced.svg'

import IntensityOneIcon from '../../../../assets/codicons/intensity-1.svg'
import IntensityTwoIcon from '../../../../assets/codicons/intensity-2.svg'
import IntensityThreeIcon from '../../../../assets/codicons/intensity-3.svg'
import IntensityFourIcon from '../../../../assets/codicons/intensity-4.svg'

import {
  setDifficultyFilter,
  setIntensityFilter,
  clearDifficultyFilter,
  clearIntensityFilter
} from '../../../redux/actions/products/filters'

import './DifficultyIntensityFilters.scss'

import PropTypes from 'prop-types'

import { connect } from 'react-redux'

const DifficultyIntensityFilters = (props) => {
  const difficulties = [
    'introductory',
    'beginner',
    'moderate',
    'intermediate',
    'advanced'
  ]
  const intensities = ['1', '2', '3', '4']

  const clearFilter = (deletedFilter) => {
    if (deletedFilter === 'intensity') {
      props.clearIntensityFilter()
    } else if (deletedFilter === 'difficulty') {
      props.clearDifficultyFilter()
    }
    props.onFilter()
  }

  const changeDifficultyFilter = (value) => {
    props.setDifficultyFilter(value)
    props.onFilter()
  }

  const changeIntensityFilter = (value) => {
    props.setIntensityFilter(value)
    props.onFilter()
  }

  const getDifficultyIcon = (difficulty) => {
    switch (difficulty) {
      case 'introductory':
        return <IntroductoryIcon />
      case 'beginner':
        return <BeginnerIcon />
      case 'moderate':
        return <ModerateIcon />
      case 'intermediate':
        return <IntermediateIcon />
      case 'advanced':
        return <AdvancedIcon />
    }
  }

  const getIntensityIcon = (intensity) => {
    switch (intensity) {
      case '1':
        return <IntensityOneIcon />
      case '2':
        return <IntensityTwoIcon />
      case '3':
        return <IntensityThreeIcon />
      case '4':
        return <IntensityFourIcon />
    }
  }

  let difficultyFilters = (
    <ul>
      {difficulties.map((difficulty, idx) => (
        <li key={idx}>
          <AloCheckbox
            value={difficulty}
            active={props.difficulty === difficulty}
            icon={getDifficultyIcon(difficulty)}
            handleChange={changeDifficultyFilter}
          />
        </li>
      ))}
    </ul>
  )

  let intensityFilters = (
    <ul>
      {intensities.map((intensity, idx) => (
        <li key={idx}>
          <AloCheckbox
            value={intensity}
            active={props.intensity === intensity}
            icon={getIntensityIcon(intensity)}
            handleChange={changeIntensityFilter}
          />
        </li>
      ))}
    </ul>
  )

  let clearIntensity = props.intensity ? (
    <a
      className='DifficultyIntensityFilters__clear'
      onClick={() => {
        clearFilter('intensity')
      }}
    >
      Clear
    </a>
  ) : null

  let clearDifficulty = props.difficulty ? (
    <a
      className='DifficultyIntensityFilters__clear'
      onClick={() => {
        clearFilter('difficulty')
      }}
    >
      Clear
    </a>
  ) : null

  return (
    <div className='DifficultyIntensityFilters'>
      <form>
        <div className='DifficultyIntensityFilters__filterSectionTitle'>
          <div className='DifficultyIntensityFilters__difficulty-label'>
            <span>Difficulty</span>
            <HelpPopup
              trigger={
                <a href='#' className='hovertip'>
                  ?
                </a>
              }
              topOffset={-20}
              width={200}
            >
              Difficulty refers to the level of skill and technique called for
              in a class
            </HelpPopup>
          </div>
          {clearDifficulty}
        </div>
        {difficultyFilters}
        <div className='DifficultyIntensityFilters__filterSectionTitle'>
          <div className='DifficultyIntensityFilters__intensity-label'>
            <span>intensity</span>
            <HelpPopup
              trigger={
                <a href='#' className='hovertip'>
                  ?
                </a>
              }
              topOffset={-20}
              width={200}
            >
              Intensity is not the same as difficulty; it refers to the amount
              of exertion that a class requires.
            </HelpPopup>
          </div>
          {clearIntensity}
        </div>
        {intensityFilters}
      </form>
    </div>
  )
}

DifficultyIntensityFilters.propTypes = {
  difficulty: PropTypes.string,
  intensity: PropTypes.string,
  setDifficultyFilter: PropTypes.func,
  setIntensityFilter: PropTypes.func,
  clearDifficultyFilter: PropTypes.func,
  clearIntensityFilter: PropTypes.func,
  onFilter: PropTypes.func
}

const mapStateToProps = (state) => {
  return {
    difficulty: state.ui.products.filters.difficulty,
    intensity: state.ui.products.filters.intensity
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    setDifficultyFilter: (difficulty) => {
      dispatch(setDifficultyFilter(difficulty))
    },
    setIntensityFilter: (intensity) => {
      dispatch(setIntensityFilter(intensity))
    },
    clearDifficultyFilter: () => {
      dispatch(clearDifficultyFilter())
    },
    clearIntensityFilter: () => {
      dispatch(clearIntensityFilter())
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DifficultyIntensityFilters)
